import { Component, OnInit } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { TradeSwapComponent } from "@modules/trade/modals/trade-swap-modal/trade-swap.component";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { Fiat, Offer } from "@models";
import { ActivatedRoute } from "@angular/router";
import { AccountService } from "@modules/account/services/account.service";
import { TooltipService } from "@main-services/tooltip.service";
import { UserService } from "@main-services/user.service";
import { TradableOfferService } from "@modules/trade/services/tradable-offer-service";
import { Tradable } from "@models/interfaces/tradable";

@Component({
	template: "",
	standalone: false
})
export class TradeSwapDialogComponent implements OnInit {
	constructor(
		private modalService: ModalService,
		private tradableOfferService: TradableOfferService,
		private route: ActivatedRoute,
		private accountService: AccountService,
		private tooltipService: TooltipService,
		private userService: UserService
	) {}

	public ngOnInit(): void {
		this.route.params.forEach(({ tradableId = "" }) => {
			const { offer, tradable } = this.tradableOfferService.generateTradableOffer(tradableId);
			offer.setType(TRADE_TYPE.SWAP);

			if (this.accountService.account.getSwapDisabled() || this.userService.isUnverified) {
				return;
			}

			// Trade/swap/{tradableId}
			if (tradableId) {
				if (!tradable) {
					this.displayGenericSwapPopupIfAvailable();
					return;
				}

				const cryptoWallets = this.tooltipService.getCryptoWalletsAboveMinSell(tradable, this.defaultFiat);
				if (cryptoWallets.length === 0 || !tradable.isSellActive() || !tradable.isAvailable()) {
					this.displayGenericSwapPopupIfAvailable();
				} else {
					this.displayGenericSwapPopupFor(offer, tradable);
				}
			} else {
				this.displayGenericSwapPopupIfAvailable();
			}
		});
	}

	// Trade/swap
	private displayGenericSwapPopupIfAvailable(): void {
		const allTradableWallets = this.tooltipService.getAvailableSwapWallets(this.defaultFiat);
		if (allTradableWallets.length > 0) {
			this.modalService.create(TradeSwapComponent).present();
		}
	}

	private get defaultFiat(): Fiat {
		return this.accountService.getDefaultFiat();
	}

	private displayGenericSwapPopupFor(offer: Offer, tradable: Tradable): void {
		offer.setCurrencyId(tradable.getId());
		this.modalService
			.create(TradeSwapComponent, {
				externalLaunchOptions: {
					id: offer.getCurrencyId()
				}
			})
			.present();
	}
}
